import http from '@/util/http'

export default {
  // 公告列表
  initNoticeList (data = {}) {
    return http({
      url: `/api/systemNotice/queryNoticeList/${data.page}/${data.size}`,
      method: 'post',
      data: data
    })
  },
  // 公告详情
  queryNoticeDetail (data = {}) {
    return http({
      url: `/api/systemNotice/queryNoticeBySnId/${data.snId}`,
      method: 'post'
    })
  },
  // 公告管理列表
  noticeAdministrationList (data = {}) {
    return http({
      url: `/api/systemNotice/queryNoticeAdministration/${data.page}/${data.size}`,
      method: 'post',
      data
    })
  },
  // 编辑公告
  updataNotice (data = {}) {
    return http({
      url: '/api/systemNotice/updateNotice',
      method: 'post',
      data
    })
  },
  // 新增公告
  addNotice (data = {}) {
    return http({
      url: '/api/systemNotice/addNotice',
      method: 'post',
      data
    })
  },
  // 上传附件
  uploadNoticeFile (data = []) {
    return http({
      url: '/api/systemNotice/addAttachment',
      method: 'post',
      data
    })
  },
  // 下载附件
  downloadNoticeFile (data = {}) {
    return http({
      url: `/api/systemAttachment/download/${data.guid}`,
      method: 'get',
      responseType: 'blob'
    })
  },
  // 关闭公告
  closeNotice (data = {}) {
    return http({
      url: `/api/systemNotice/updateNoticeMessage/${data.snId}/${data.flag}`,
      method: 'post',
      data
    })
  },
  // 查询所有公告 已读 未读
  getNoticeStatus () {
    return http({
      url: '/api/systemNotice/queryNoticeMessageByAll',
      method: 'post'
    })
  }
}
